import React, { Suspense, useState } from 'react';
import { useToast } from '../../../../hooks/useToast';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ActionMenu, { Action } from '../../../../components/ui/materialui/actionMenu';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import { StatusCode, TipoFuncionalidad } from '../../../../utils/enums';
import { config } from '../../../../utils/config';
import { institucionFinanciera } from '../models/institucionFinanciera';
import { mutuosVigentes } from '../service/servicesInstitucionFinanciera';
import { usePermissions } from '../../../../components/auth/ProtectedRoute';

interface IProps {
  institucionFinanciera: institucionFinanciera;
  control: any;
  setInstitucionEditar: React.Dispatch<React.SetStateAction<institucionFinanciera | undefined>>;
  setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
}

const AccionesInstitucion: React.FC<IProps> = ({ institucionFinanciera, control, setInstitucionEditar, setModalDetalle }) => {

  const { hasPermission } = usePermissions();
  const puedeEditar = hasPermission(TipoFuncionalidad.Maestros_editar);

  const [modalConfirmacion, setModalConfirmacion] = useState({
    show: false,
    title: '',
    message: '',
    metodo: () => {
    },
  })

  const { addToast } = useToast();

  const handleEditarClick = async () => {

    // Ver si tiene mutuos vigentes
    const response = await mutuosVigentes(institucionFinanciera.rut);

    if (response.status !== StatusCode.Ok)
      return;

    if (response?.data === true) {
      addToast({
        mostrar: true,
        titulo: 'warning',
        tipo: 'Warning',
        mensaje: 'No se puede modificar institución, tiene mutuos asociados.'
      });
      return;
    }

    setInstitucionEditar({
      ...institucionFinanciera,
    });

    setModalDetalle(true)
  }

const actions: Action[] = [];
  if (puedeEditar) {
    actions.push({
      label: "Editar",
      icon: <EditIcon fontSize="small" />,
      onClick: () => handleEditarClick()
    });
  };
  return (
    <>
      <ActionMenu actions={actions} />
      <ConfirmationModal
        onHide={() => setModalConfirmacion({ ...modalConfirmacion, show: false })}
        onConfirm={modalConfirmacion.metodo}
        show={modalConfirmacion.show}
        title={modalConfirmacion.title}
        message={modalConfirmacion.message}
      />
    </>
  );
};

export default AccionesInstitucion;
